import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { FarmPickerOption } from 'components/FarmPickerField';

export type AppSelectionHeaderFarmPicker = {
  disabled?: boolean;
  label: string;
  loading?: boolean;
  onChange: (value: string | number) => void;
  options: FarmPickerOption[];
  placeholder?: string;
  value?: string | number;
};

type AppSelectionHeaderContextValue = {
  farmPicker: AppSelectionHeaderFarmPicker | null;
  setFarmPicker: (picker: AppSelectionHeaderFarmPicker | null) => void;
};

const AppSelectionHeaderContext = createContext<AppSelectionHeaderContextValue | null>(null);

export function AppSelectionHeaderProvider({ children }: { children: React.ReactNode }) {
  const [farmPicker, setFarmPickerState] = useState<AppSelectionHeaderFarmPicker | null>(null);

  const setFarmPicker = useCallback((picker: AppSelectionHeaderFarmPicker | null) => {
    setFarmPickerState(picker);
  }, []);

  const value = useMemo(
    () => ({ farmPicker, setFarmPicker }),
    [farmPicker, setFarmPicker],
  );

  return (
    <AppSelectionHeaderContext.Provider value={value}>
      {children}
    </AppSelectionHeaderContext.Provider>
  );
}

export function useAppSelectionHeader() {
  const context = useContext(AppSelectionHeaderContext);
  if (!context) {
    throw new Error('useAppSelectionHeader must be used within AppSelectionHeaderProvider');
  }
  return context;
}

export function useOptionalAppSelectionHeader() {
  return useContext(AppSelectionHeaderContext);
}
